import { render, staticRenderFns } from "./ProjectSummary.vue?vue&type=template&id=069f24c6"
import script from "./ProjectSummary.vue?vue&type=script&lang=ts"
export * from "./ProjectSummary.vue?vue&type=script&lang=ts"
import style0 from "./ProjectSummary.vue?vue&type=style&index=0&id=069f24c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports